<template>
  <div class="crop-map" ref="mapName"/>
</template>

<script>
const doneImgFile = require('../../assets/icons/done.png')
const closeIconFile = require('../../assets/icons/close.png')
const mapMarkerIconFile = require('../../assets/icons/mapMarker.png')
import {getLetterFromIndex} from '../../lib/helpers'
export default {
  name: 'cropMap',
  props: {
    cropMapSelection: {
      type: Boolean,
      required: true
    },
    cropData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      mapCircle: null,
      mapPolygon: null,
      circleShape: false,
      polygonShape: this.cropData.shapeType === 3,
      deleteMarker: null,
      shapeSetted: false,
      cropStart: null,
      cropStartDelete: null,
      cropEnd: null,
      cropEndDelete: null,
      map: null,
      pointTags: [],
      editable: true
    }
  },
  mounted () {
    this.loadMap()
  },
  methods: {
    zoomControl (controlDiv, map) {
      const zoomControl = document.createElement('div')
      const zoomInUI = document.createElement('div')

      zoomInUI.style.width = '35px'
      zoomInUI.style.height = '35px'
      zoomInUI.style.backgroundColor = '#fff'
      zoomInUI.style.border = '2px solid #fff'
      zoomInUI.style.borderRadius = '3px'
      zoomInUI.style.boxShadow = '0px 4px 4px rgba(0, 0, 0, 0.25)'
      zoomInUI.style.cursor = 'pointer'
      zoomInUI.style.marginTop = '8px'
      zoomInUI.style.marginBottom = '10px'
      zoomInUI.style.textAlign = 'center'
      zoomInUI.style.borderRadius = '50%'
      zoomControl.appendChild(zoomInUI)

      const zoomInText = document.createElement('div')

      zoomInText.style.color = '#000000'
      zoomInText.style.fontFamily = 'Roboto,Arial,sans-serif'
      zoomInText.style.fontSize = '25px'
      zoomInText.style.lineHeight = '30px'
      zoomInText.style.paddingLeft = '5px'
      zoomInText.style.paddingRight = '5px'
      zoomInText.innerHTML = '+'
      zoomInUI.appendChild(zoomInText)

      zoomInUI.addEventListener('click', () => {
        map.setZoom(map.zoom + 1)
      })

      const zoomOutUI = document.createElement('div')

      zoomOutUI.style.width = '35px'
      zoomOutUI.style.height = '35px'
      zoomOutUI.style.backgroundColor = '#fff'
      zoomOutUI.style.border = '2px solid #fff'
      zoomOutUI.style.borderRadius = '3px'
      zoomOutUI.style.boxShadow = '0px 4px 4px rgba(0, 0, 0, 0.25)'
      zoomOutUI.style.cursor = 'pointer'
      zoomOutUI.style.marginTop = '8px'
      zoomOutUI.style.marginBottom = '10px'
      zoomOutUI.style.textAlign = 'center'
      zoomOutUI.style.borderRadius = '50%'
      zoomControl.appendChild(zoomOutUI)

      const zoomOutText = document.createElement('div')
      zoomOutText.style.color = '#000000'
      zoomOutText.style.fontFamily = 'Roboto,Arial,sans-serif'
      zoomOutText.style.fontSize = '25px'
      zoomOutText.style.lineHeight = '30px'
      zoomOutText.style.paddingLeft = '5px'
      zoomOutText.style.paddingRight = '5px'
      zoomOutText.innerHTML = '-'
      zoomOutUI.appendChild(zoomOutText)
      zoomOutUI.addEventListener('click', () => {
        map.setZoom(map.zoom - 1)
      })

      controlDiv.appendChild(zoomControl)
    },
    dataConfirmationDiv (controlDiv) {
      const dataConfirmationDiv = document.createElement('div')
      dataConfirmationDiv.id = 'dataConfirmationDiv'
      dataConfirmationDiv.style.textAlign = 'center'
      dataConfirmationDiv.style.alignSelf = 'center'
      dataConfirmationDiv.style.marginRight = '15px'
      const cData = this.cropData
      dataConfirmationDiv.style.display = (cData.location && cData.location.latitude && cData.location.longitude) || (cData.points && cData.points.length) ? 'block' : 'none'
      const confirmBtnDiv = document.createElement('div')
      confirmBtnDiv.style.marginBottom = '5px'
      const confirmBtn = document.createElement('input')
      confirmBtn.type = 'button'
      confirmBtn.style.background = '#0098E1'
      confirmBtn.style.boxShadow = '0px 4px 4px rgba(0, 152, 225, 0.25)'
      confirmBtn.style.borderRadius = '5px'
      confirmBtn.style.justifyContent = 'center'
      confirmBtn.style.alignItems = 'center'
      confirmBtn.style.paddingLeft = '10px'
      confirmBtn.style.paddingRight = '10px'
      confirmBtn.style.paddingTop = '8px'
      confirmBtn.style.paddingBottom = '8px'
      confirmBtn.style.fontFamily = 'Source Sans 3'
      confirmBtn.style.fontStyle = 'normal'
      confirmBtn.style.fontWeight = 400
      confirmBtn.style.fontSize = '1.1rem'
      confirmBtn.style.lineHeight = '28px'
      confirmBtn.style.color = '#FFFFFF'

      confirmBtn.value = this.$t('CropMap.confirmData')
      confirmBtn.addEventListener('click', () => {
        document.querySelector('#dataConfirmationDiv').style.display = 'none'
        document.querySelector('#titleText').innerHTML = this.$t('')
        if (document.querySelector('#dataEditionDiv')) {
          document.querySelector('#dataEditionDiv').style.display = 'block'
        } else {
          this.dataEditionDiv(document.querySelector('#topBannerDiv'))
        }
        const newCropData = {...this.cropData}
        let coordinatesTxt = ''
        if (this.mapCircle && this.mapCircle.getCenter()) {
          delete newCropData.points
          newCropData.location = {
            latitude: this.mapCircle.getCenter().lat(),
            longitude: this.mapCircle.getCenter().lng()
          }
          newCropData.startPoint = {
            latitude: this.cropStart.getPosition().lat(),
            longitude: this.cropStart.getPosition().lng()
          }
          newCropData.endPoint = {
            latitude: this.cropEnd.getPosition().lat(),
            longitude: this.cropEnd.getPosition().lng()
          }
          coordinatesTxt += `${this.mapCircle.getCenter().lat()},${this.mapCircle.getCenter().lng()};${this.mapCircle.getRadius()};${this.cropStart.getPosition().lat()},${this.cropStart.getPosition().lng()};${this.cropEnd.getPosition().lat()},${this.cropEnd.getPosition().lng()}`
          newCropData.coordinates = coordinatesTxt
        } else {
          delete newCropData.location
          delete newCropData.radius
          delete newCropData.startPoint
          delete newCropData.endPoint
          const points = []
          this.mapPolygon.getPath().forEach(path => {
            points.push({latitude: path.lat(), longitude: path.lng(), coordinatesString: `${path.lat()}, ${path.lng()}`})
            if (coordinatesTxt.length) {
              coordinatesTxt += `-${path.lat()},${path.lng()}`
            } else {
              coordinatesTxt = `${path.lat()},${path.lng()}`
            }
          })
          newCropData.points = points
          newCropData.coordinates = coordinatesTxt
        }
        this.$emit('update:cropData', newCropData)
      })
      confirmBtnDiv.appendChild(confirmBtn)
      dataConfirmationDiv.appendChild(confirmBtnDiv)
      const declineBtnDiv = document.createElement('div')
      const declineBtn = document.createElement('input')
      declineBtn.type = 'button'
      declineBtn.style.background = '#ECECEC'
      declineBtn.style.boxShadow = '0px 4px 4px rgba(0, 152, 225, 0.25)'
      declineBtn.style.borderRadius = '5px'
      declineBtn.style.justifyContent = 'center'
      declineBtn.style.alignItems = 'center'
      declineBtn.style.paddingLeft = '10px'
      declineBtn.style.paddingRight = '10px'
      declineBtn.style.paddingTop = '8px'
      declineBtn.style.paddingBottom = '8px'
      declineBtn.style.fontFamily = 'Source Sans 3'
      declineBtn.style.fontStyle = 'normal'
      declineBtn.style.fontWeight = 400
      declineBtn.style.fontSize = '1.1rem'
      declineBtn.style.lineHeight = '28px'
      declineBtn.style.color = '#00202F'
      declineBtn.value = this.$t('CropMap.declineData')
      declineBtn.addEventListener('click', () => {
        this.editCropData()
      })
      declineBtnDiv.appendChild(declineBtn)
      dataConfirmationDiv.appendChild(declineBtnDiv)
      controlDiv.appendChild(dataConfirmationDiv)
    },
    confirmData (controlDiv) {
      const doneUI = document.createElement('div')

      doneUI.id = 'circleUIs'
      doneUI.style.width = '45px'
      doneUI.style.height = '45px'
      doneUI.style.backgroundColor = '#0098E1'
      doneUI.style.boxShadow = '0px 4px 4px rgba(0, 0, 0, 0.25)'
      doneUI.style.cursor = 'pointer'
      doneUI.style.marginBottom = '20px'
      doneUI.style.alignItems = 'center'
      doneUI.style.borderRadius = '50%'
      doneUI.style.display = 'flex'
      doneUI.style.justifyContent = 'center'
      controlDiv.appendChild(doneUI)

      const doneImg = document.createElement('img')

      doneImg.src = doneImgFile
      doneImg.style.width = '25px'
      doneUI.appendChild(doneImg)

      doneUI.addEventListener('click', () => {
        if ((this.circleShape && this.mapCircle.getCenter()) || (this.polygonShape && this.mapPolygon.getPath().length)) {
          this.shapeSetted = true
          document.querySelector('#confirmDataDiv').style.display = 'none'
          if (this.circleShape) {
            document.querySelector('#titleText').innerHTML = this.$t('CropMap.cropStart')
          } else if (this.polygonShape) {
            document.querySelector('#titleText').innerHTML = this.$t('CropMap.confirmTitle')
            if (!document.querySelector('#dataConfirmationDiv')) {
              this.dataConfirmationDiv(document.querySelector('#topBannerDiv'))
            } else {
              document.querySelector('#dataConfirmationDiv').style.display = 'block'
            }
          }
          if (this.circleShape) {
            this.mapCircle.setOptions({fillColor: '#FFFFFF', strokeColor: '#FFFFFF'})
            this.mapCircle.setEditable(false)
            this.removeDeleteMarker()
          } else if (this.polygonShape) {
            this.mapPolygon.setOptions({fillColor: '#FFFFFF', strokeColor: '#FFFFFF'})
            this.removeDeleteMarker()
            this.editable = false
          }
        } else {
          this.$root.snack.show({text: this.$t('CropMap.requiredData'), error: true})
        }
      })
    },
    addCropStartDeleteMarker (map) {
      this.cropStartDelete = new google.maps.Marker({
        position: { lat: this.cropStart.getPosition().lat() + 0.001, lng: this.cropStart.getPosition().lng() + 0.0004 },
        map,
        icon: closeIconFile,
        zIndex: 6
      })
      this.cropStartDelete.addListener('click', () => {
        if (document.querySelector('#dataConfirmationDiv').style.display !== 'none') {
          document.querySelector('#dataConfirmationDiv').style.display = 'none'
        }
        this.cropStartDelete.setMap(null)
        this.cropStartDelete = null
        this.cropStart.setMap(null)
        this.cropStart = null
        document.querySelector('#titleText').innerHTML = this.$t('CropMap.cropStart')
        document.querySelector('#samePositionBtn').style.display = 'none'
      })
    },
    addCropEndDeleteMarker (map) {
      this.cropEndDelete = new google.maps.Marker({
        position: { lat: this.cropEnd.getPosition().lat() + 0.001, lng: this.cropEnd.getPosition().lng() + 0.0004 },
        map,
        icon: closeIconFile,
        zIndex: 5
      })
      this.cropEndDelete.addListener('click', () => {
        if (document.querySelector('#dataConfirmationDiv').style.display !== 'none') {
          document.querySelector('#dataConfirmationDiv').style.display = 'none'
        }
        this.cropEndDelete.setMap(null)
        this.cropEndDelete = null
        this.cropEnd.setMap(null)
        this.cropEnd = null
        if (this.cropStart) {
          document.querySelector('#samePositionBtn').style.display = 'block'
          document.querySelector('#titleText').innerHTML = this.$t('CropMap.cropEnd')
        }
      })
    },
    addCropEndPoint (latitude, longitude, map, isSavedPoint) {
      if (this.cropEnd) {
        this.cropEnd.setMap(null)
        this.cropEnd = null
      }
      this.cropEnd = new google.maps.Marker({
        position: {lat: latitude, lng: longitude},
        map,
        icon: mapMarkerIconFile,
        zIndex: 1
      })
      if (this.cropEndDelete) {
        this.cropEndDelete.setMap(null)
        this.cropEndDelete = null
      }
      if (document.querySelector('#samePositionBtn')) document.querySelector('#samePositionBtn').style.display = 'none'
      if (!isSavedPoint) this.addCropEndDeleteMarker(map)
      if (this.cropStart) {
        if (document.querySelector('#titleText')) document.querySelector('#titleText').innerHTML = this.$t('CropMap.confirmTitle')
        if (document.querySelector('#dataConfirmationDiv')) document.querySelector('#dataConfirmationDiv').style.display = 'block'
      }
    },
    addCropStartPoint (latitude, longitude, map, isSavedPoint) {
      if (this.cropStart) {
        this.cropStart.setMap(null)
        this.cropStart = null
      }
      this.cropStart = new google.maps.Marker({
        position: {lat: latitude, lng: longitude},
        map,
        icon: mapMarkerIconFile,
        zIndex: 2
      })
      if (this.cropStartDelete) {
        this.cropStartDelete.setMap(null)
        this.cropStartDelete = null
      }
      if (!isSavedPoint) this.addCropStartDeleteMarker(map)
      if (this.cropEnd) {
        document.querySelector('#titleText').innerHTML = this.$t('CropMap.confirmTitle')
        document.querySelector('#dataConfirmationDiv').style.display = 'block'
      } else {
        if (document.querySelector('#samePositionBtn')) document.querySelector('#samePositionBtn').style.display = 'block'
        if (document.querySelector('#titleText')) document.querySelector('#titleText').innerHTML = this.$t('CropMap.cropEnd')
      }
    },
    addCircleDeleteMarker (latitude, longitude, map) {
      this.deleteMarker = new google.maps.Marker({
        position: {lat: latitude + this.mapCircle.getRadius() / 111139, lng: longitude + this.mapCircle.getRadius() / 111139},
        map,
        icon: closeIconFile
      })
      this.deleteMarker.addListener('click', () => {
        this.removeDeleteMarker()
        if (this.circleShape) {
          this.resetMapCircle()
        } else if (this.polygonShape) {
          this.resetMapPolygon()
        }
      })
    },
    addPolygonDeleteMarker (latitude, longitude, map) {
      this.deleteMarker = new google.maps.Marker({
        position: {lat: latitude + 0.004, lng: longitude + 0.0002},
        map,
        icon: closeIconFile
      })
      this.deleteMarker.addListener('click', () => {
        this.removeDeleteMarker()
        if (this.circleShape) {
          this.resetMapCircle()
        } else if (this.polygonShape) {
          this.resetMapPolygon()
        }
      })
    },
    addPointToShape (event, map) {
      if (this.shapeSetted && this.mapCircle) {
        if (!this.cropStart) {
          this.addCropStartPoint(event.latLng.lat(), event.latLng.lng(), map)
        } else if (!this.cropEnd) {
          this.addCropEndPoint(event.latLng.lat(), event.latLng.lng(), map)
        }
      }
      if (this.circleShape && !this.mapCircle.getCenter()) {
        this.addCircleDeleteMarker(event.latLng.lat(), event.latLng.lng(), map)
      } else if (this.polygonShape && !this.mapPolygon.getPath().length) {
        this.addPolygonDeleteMarker(event.latLng.lat(), event.latLng.lng(), map)
      }
      if (this.polygonShape) {
        if (this.editable) {
          const path = this.mapPolygon.getPath()
          path.push(event.latLng)
          this.addPolygonPointName(event.latLng.lat(), event.latLng.lng(), map, path.length)
        }
      } else if (this.circleShape) {
        if (this.mapCircle.getEditable()) {
          this.mapCircle.setCenter(event.latLng)
        }
      }
    },
    relocateDeleteBtn () {
      if (this.mapCircle.getCenter()) {
        this.deleteMarker.setPosition({lat: this.mapCircle.getCenter().lat() + this.mapCircle.getRadius() / 111139, lng: this.mapCircle.getCenter().lng() + this.mapCircle.getRadius() / 111139})
      } else if (this.mapPolygon.getPath().length) {
        const limitPosition = this.getPolygonLimitPosition()
        this.deleteMarker.setPosition({lat: limitPosition.lat + 0.0001, lng: limitPosition.lng + 0.0001})
      }
    },
    loadMap () {
      const element = this.$refs.mapName
      const cropData = this.cropData
      const options = {
        zoom: 5,
        center: {lat: -35.026974, lng: -64.466206},
        mapTypeId: google.maps.MapTypeId.HYBRID,
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        gestureHandling: 'cooperative',
        mapId: 'crop-map',
        disableDefaultUI: true
      }
      this.map = new google.maps.Map(element, options)

      if (cropData.location && cropData.location.latitude && cropData.location.latitude) {
        // TODO: Set bounds to current lot
      } else if (cropData.points && cropData.points.length) {
        const bounds = new google.maps.LatLngBounds()
        cropData.points.forEach(point => {
          bounds.extend(new google.maps.LatLng(point.latitude, point.longitude))
        })
        this.map.fitBounds(bounds)
      }

      const gradientDiv = document.createElement('div')
      gradientDiv.style.height = '50px'
      gradientDiv.style.width = '100%'
      gradientDiv.style.background = 'linear-gradient(180deg, rgba(0,32,47,1) 0%, rgba(0,32,47,0.75) 60%, rgba(0,212,255,0) 100%)'
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(gradientDiv)

      const zoomControlDiv = document.createElement('div')
      zoomControlDiv.style.marginRight = '20px'
      zoomControlDiv.style.marginBottom = '10px'
      zoomControlDiv.style.display = 'flex'
      this.zoomControl(zoomControlDiv, this.map)
      this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlDiv)

      const topBannerDiv = document.createElement('div')
      topBannerDiv.id = 'topBannerDiv'
      topBannerDiv.style.position = 'absolute'
      topBannerDiv.style.left = 0
      topBannerDiv.style.right = 0
      topBannerDiv.style.marginLeft = 'auto'
      topBannerDiv.style.marginRight = 'auto'

      const titleDiv = document.createElement('div')
      const titleText = document.createElement('p')
      titleText.id = 'titleText'
      let innerHTML = ''
      if ((cropData.shapeType === 1 && (!cropData.location || !cropData.location.latitude || !cropData.location.latitude)) || (cropData.shapeType === 3 && (!cropData.points || !cropData.points.length))) {
        innerHTML = this.cropData.shapeType === 3 ? this.$t('CropMap.markPolygonLot') : this.$t('CropMap.markLot', [this.cropData.name])
      }
      titleText.innerHTML = innerHTML
      titleText.style.fontFamily = 'Source Sans 3'
      titleText.style.fontStyle = 'normal'
      titleText.style.fontWeight = '700'
      titleText.style.fontSize = '1.3rem'
      titleText.style.lineHeight = '45px'
      titleText.style.textAlign = 'center'
      titleText.style.color = '#FFFFFF'
      titleText.style.marginBottom = '0px'
      titleDiv.appendChild(titleText)
      const samePositionBtn = document.createElement('input')
      samePositionBtn.id = 'samePositionBtn'
      samePositionBtn.type = 'button'
      samePositionBtn.style.background = '#0098E1'
      samePositionBtn.style.boxShadow = '0px 4px 4px rgba(0, 152, 225, 0.25)'
      samePositionBtn.style.borderRadius = '5px'
      samePositionBtn.style.fontFamily = 'Source Sans 3'
      samePositionBtn.style.fontStyle = 'normal'
      samePositionBtn.style.fontWeight = '400'
      samePositionBtn.style.fontSize = '22px'
      samePositionBtn.style.lineHeight = '28px'
      samePositionBtn.style.color = '#FFFFFF'
      samePositionBtn.style.width = 'fit-content'
      samePositionBtn.style.margin = 'auto'
      samePositionBtn.style.paddingLeft = '25px'
      samePositionBtn.style.paddingRight = '25px'
      samePositionBtn.value = this.$t('CropMap.samePosition')
      samePositionBtn.style.display = 'none'
      samePositionBtn.addEventListener('click', () => {
        this.addCropEndPoint(this.cropStart.getPosition().lat(), this.cropStart.getPosition().lng(), this.map)
        this.addCropEndDeleteMarker(this.map)
        if (this.cropStart) {
          document.querySelector('#titleText').innerHTML = this.$t('CropMap.confirmTitle')
          document.querySelector('#dataConfirmationDiv').style.display = 'block'
        }
        samePositionBtn.style.display = 'none'
      })
      titleDiv.appendChild(samePositionBtn)
      topBannerDiv.appendChild(titleDiv)
      this.dataEditionDiv(topBannerDiv)
      this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(topBannerDiv)

      const confirmDataDiv = document.createElement('div')
      confirmDataDiv.id = 'confirmDataDiv'
      confirmDataDiv.style.marginBottom = '10px'
      confirmDataDiv.style.display = cropData.location || cropData.points ? 'none' : 'block'
      this.confirmData(confirmDataDiv)
      this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(confirmDataDiv)

      if (this.cropData.shapeType === 1) {
        this.mapCircle = new google.maps.Circle({
          strokeColor: '#0098E1',
          strokeOpacity: 0.6,
          strokeWeight: 5,
          fillColor: '#0098E1',
          fillOpacity: 0.6,
          map: this.map,
          radius: 400,
          editable: true,
          draggable: false
        })

        if (cropData.location && cropData.location.latitude && cropData.location.latitude) {
          this.circleShape = false
          this.shapeSetted = true
          this.mapCircle.setOptions({
            fillColor: '#FFFFFF',
            strokeColor: '#FFFFFF',
            editable: false,
            draggable: false
          })
          this.mapCircle.setCenter({lat: cropData.location.latitude, lng: cropData.location.longitude})
          if (cropData.radius) {
            this.mapCircle.setRadius(cropData.radius)
          }
          this.addCropStartPoint(cropData.startPoint.latitude, cropData.startPoint.longitude, this.map, true)
          this.addCropEndPoint(cropData.endPoint.latitude, cropData.endPoint.longitude, this.map, true)
          this.addCircleDeleteMarker(this.mapCircle.getCenter().lat(), this.mapCircle.getCenter().lng(), this.map)
          this.deleteMarker.setMap(null)
        }

        google.maps.event.addListener(this.mapCircle, 'radius_changed', this.relocateDeleteBtn)
        google.maps.event.addListener(this.mapCircle, 'center_changed', this.relocateDeleteBtn)
        google.maps.event.addListener(this.mapCircle, 'click',  (evt) => { this.addPointToShape(evt, this.map) })
      } else if (this.cropData.shapeType === 3) {
        this.mapPolygon = new google.maps.Polygon({
          strokeColor: '#0098E1',
          strokeOpacity: 0.6,
          strokeWeight: 5,
          fillColor: '#0098E1',
          fillOpacity: 0.6,
          editable: false,
          draggable: false,
          map: this.map
        })

        if (cropData.points && cropData.points.length) {
          this.polygonShape = false
          this.mapPolygon.setOptions({
            fillColor: '#FFFFFF',
            strokeColor: '#FFFFFF',
            editable: false,
            draggable: false
          })
          const path = this.mapPolygon.getPath()
          cropData.points.forEach((position, index) => {
            path.push(new google.maps.LatLng(position.latitude, position.longitude))
            this.addPolygonPointName(position.latitude, position.longitude, this.map, index + 1)
          })
          this.mapPolygon.setPath(path)
          const limitPosition = this.getPolygonLimitPosition()
          this.addPolygonDeleteMarker(limitPosition.lat, limitPosition.lng, this.map)
          this.deleteMarker.setMap(null)
          this.editable = false
        }
      }

      this.map.addListener('click', (evt) => { this.addPointToShape(evt, this.map) })
      google.maps.event.addListener(this.mapPolygon, 'drag', this.relocateDeleteBtn)
    },
    removeDeleteMarker () {
      if (this.deleteMarker) {
        this.deleteMarker.setMap(null)
      }
    },
    resetMapCircle () {
      this.mapCircle.setOptions({fillColor: '#0098E1', strokeColor: '#0098E1'})
      this.mapCircle.setCenter(null)
      this.mapCircle.setEditable(true)
    },
    resetMapPolygon () {
      this.mapPolygon.setOptions({fillColor: '#0098E1', strokeColor: '#0098E1'})
      this.mapPolygon.setPath([])
      this.pointTags.forEach(pointTag => {
        pointTag.setMap(null)
      })
      this.pointTags = []
      this.editable = true
    },
    getPolygonLimitPosition () {
      const positions = this.mapPolygon.getPath()
      let maxLat = null
      let maxLng = null
      positions.forEach(position => {
        if (!maxLat || position.lat() > maxLat) {
          maxLat = position.lat()
        }
        if (!maxLng || position.lng() > maxLng) {
          maxLng = position.lng()
        }
      })
      return {
        lat: maxLat,
        lng: maxLng
      }
    },
    addPolygonPointName (latitude, longitude, map, pointsLength) {
      const pointTag = document.createElement('div')
      pointTag.className = 'point-tag'
      pointTag.textContent = `${getLetterFromIndex(pointsLength)}`

      this.pointTags.push(new google.maps.marker.AdvancedMarkerElement({
        position: {lat: latitude + 0.0005, lng: longitude + 0.0001},
        map,
        content: pointTag
      }))
    },
    recenterMap () {
      this.map.setCenter()
    },
    editCropData () {
      if (document.querySelector('#dataConfirmationDiv')) {
        document.querySelector('#dataConfirmationDiv').style.display = 'none'
      }
      if (document.querySelector('#dataEditionDiv')) {
        document.querySelector('#dataEditionDiv').style.display = 'none'
      }
      document.querySelector('#titleText').innerHTML = this.cropData.shapeType === 3 ? this.$t('CropMap.markPolygonLot') : this.$t('CropMap.markLot', [this.cropData.name])
      this.shapeSetted = false
      document.querySelector('#confirmDataDiv').style.display = 'block'
      if (this.mapCircle && this.mapCircle.getCenter()) {
        this.cropStart.setMap(null)
        this.cropStart = null
        if (this.cropStartDelete) this.cropStartDelete.setMap(null)
        this.cropStartDelete = null
        this.cropEnd.setMap(null)
        this.cropEnd = null
        if (this.cropEndDelete) this.cropEndDelete.setMap(null)
        this.cropEndDelete = null
        this.mapCircle.setOptions({fillColor: '#0098E1', strokeColor: '#0098E1'})
        this.mapCircle.setEditable(true)
        this.circleShape = true
        document.querySelector('#circleUI').style.border = '5px solid #0098E1'
      } else if (this.mapPolygon) {
        this.mapPolygon.setOptions({fillColor: '#0098E1', strokeColor: '#0098E1'})
        this.polygonShape = true
        const limitPosition = this.getPolygonLimitPosition()
        this.addPolygonDeleteMarker(limitPosition.lat, limitPosition.lng, this.map)
        this.editable = true
      }
    },
    dataEditionDiv (controlDiv) {
      const dataEditionDiv = document.createElement('div')
      dataEditionDiv.id = 'dataEditionDiv'
      dataEditionDiv.style.textAlign = 'center'
      dataEditionDiv.style.alignSelf = 'center'
      dataEditionDiv.style.marginRight = '15px'
      const cData = this.cropData
      dataEditionDiv.style.display = (cData.location && cData.location.latitude && cData.location.longitude) || (cData.points && cData.points.length) ? 'block' : 'none'
      const editBtnDiv = document.createElement('div')
      const editBtn = document.createElement('input')
      editBtn.type = 'button'
      editBtn.style.marginTop = '10px'
      editBtn.style.background = '#ECECEC'
      editBtn.style.boxShadow = '0px 4px 4px rgba(0, 152, 225, 0.25)'
      editBtn.style.borderRadius = '5px'
      editBtn.style.justifyContent = 'center'
      editBtn.style.alignItems = 'center'
      editBtn.style.paddingLeft = '10px'
      editBtn.style.paddingRight = '10px'
      editBtn.style.paddingTop = '8px'
      editBtn.style.paddingBottom = '8px'
      editBtn.style.fontFamily = 'Source Sans 3'
      editBtn.style.fontStyle = 'normal'
      editBtn.style.fontWeight = 400
      editBtn.style.fontSize = '1.1rem'
      editBtn.style.lineHeight = '28px'
      editBtn.style.color = '#00202F'
      editBtn.value = this.$t('CropMap.editData')
      editBtn.addEventListener('click', () => {
        this.editCropData()
      })
      editBtnDiv.appendChild(editBtn)
      dataEditionDiv.appendChild(editBtnDiv)
      controlDiv.appendChild(dataEditionDiv)
    
    }
  },
  computed: {
    polygonPath () {
      return this.mapPolygon && this.mapPolygon.getPath() ? this.mapPolygon.getPath() : 0
    }
  },
  watch: {
    'cropData.devices' (newVal, oldVal) {
      if (!newVal || newVal.length === 0) return

      if (!oldVal || oldVal.length === 0 || newVal[0] !== oldVal[0] && this.pointTags.length === 0) {
        const firstDevice = this.$store.getters.devices.find(device => device.id === newVal[0])
        if (!firstDevice || !firstDevice.installationCoordinates) return

        this.map.setCenter({lat: firstDevice.installationCoordinates.latitude, lng: firstDevice.installationCoordinates.longitude})
        this.map.setZoom(14)
      }
    }
  }
}

</script>

<style>
.point-tag {
  background-color: #FDEBA1;
  border-radius: 50%;
  color: #000000;
  font-size: 12px;
  position: relative;
  width: 20px !important;
  height: 20px !important;
  text-align: center;
  align-content: center;
}
</style>


// WEBPACK FOOTER //
// CropMap.vue?81ac69d2